/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleCalendarTriggerDto } from './equipment-schedule-calendar-trigger-dto';
import { EquipmentScheduleCalendarStates } from './equipment-schedule-calendar-states';


export interface EquipmentCalendarScheduleByIdResponseDto { 
    id?: string;
    name?: string | null;
    triggers?: Array<EquipmentScheduleCalendarTriggerDto> | null;
    windowStart?: string;
    windowEnd?: string;
    state?: EquipmentScheduleCalendarStates;
    assignedCount?: number;
    createdDate?: string;
    updatedDate?: string | null;
}



